import React from 'react'
import './ExitButtonWhite.scss'

export const ExitButtonWhite = ({ handleClick }) => {
  return <button className='exit-button-white' onClick={handleClick} />
}
